var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6519_26364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 13.125H4.33211C3.95347 13.125 3.76415 13.125 3.67649 13.0501C3.60042 12.9852 3.56006 12.8877 3.56791 12.788C3.57695 12.673 3.71082 12.5392 3.97855 12.2714L9.29289 6.95711C9.5404 6.7096 9.66416 6.58584 9.80686 6.53947C9.93239 6.49869 10.0676 6.49869 10.1931 6.53947C10.3358 6.58584 10.4596 6.7096 10.7071 6.95711L13.125 9.375V10.125M10.125 13.125C11.1751 13.125 11.7001 13.125 12.1012 12.9206C12.454 12.7409 12.7409 12.454 12.9206 12.1012C13.125 11.7001 13.125 11.1751 13.125 10.125M10.125 13.125H4.875C3.8249 13.125 3.29985 13.125 2.89877 12.9206C2.54596 12.7409 2.25913 12.454 2.07936 12.1012C1.875 11.7001 1.875 11.1751 1.875 10.125V4.875C1.875 3.8249 1.875 3.29985 2.07936 2.89877C2.25913 2.54596 2.54596 2.25913 2.89877 2.07936C3.29985 1.875 3.8249 1.875 4.875 1.875H10.125C11.1751 1.875 11.7001 1.875 12.1012 2.07936C12.454 2.25913 12.7409 2.54596 12.9206 2.89877C13.125 3.29985 13.125 3.8249 13.125 4.875V10.125M6.5625 5.3125C6.5625 6.00286 6.00286 6.5625 5.3125 6.5625C4.62214 6.5625 4.0625 6.00286 4.0625 5.3125C4.0625 4.62214 4.62214 4.0625 5.3125 4.0625C6.00286 4.0625 6.5625 4.62214 6.5625 5.3125Z",
    stroke: "#808795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6519_26364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/img-icon.e17ea53b05be7c0f16a045816a749662.svg";
export { ForwardRef as ReactComponent };